var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"cursor":"default"},attrs:{"tooltip":_vm.tooltip,"flow":"up"}},[_c('span',{class:['material-icons', _vm.iconStyle]},[_vm._v(_vm._s(_vm.iconName))])])}
var staticRenderFns = []

export { render, staticRenderFns }